import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import debounce from 'lodash.debounce';
import axios from '../utils/axiosConfig';
import { logout, setAuthToken, isTokenValid } from '../utils/auth';
import '../styles/VendorDashboard.css';
import '../styles/CustomerRedemption.css';
import EmailCampaignModal from './EmailCampaignModal';
import GeneralDetails from './VendorTabs/GeneralDetails';
import CustomerSearch from './VendorTabs/CustomerSearch';
import CustomerProfile from './VendorTabs/CustomerProfile';
import SpecialsAndMenus from './VendorTabs/SpecialsAndMenus';
import BookingManagement from './VendorTabs/BookingManagement';
import EmailChange from './EmailChange';
import PasswordReset from './PasswordReset';
import EventsManagement from './VendorTabs/EventsManagement';
import Reporting from './VendorTabs/Reporting';
import HomeTab from './VendorTabs/HomeTab';
import ReviewManagement from './VendorTabs/ReviewManagement';
import LoyaltyPrograms from './VendorTabs/LoyaltyPrograms';
import Campaigns from './VendorTabs/Campaigns';
import BookingV2Dashboard from './VendorTabs/BookingV2Dashboard';


// Modern icons using SVG for better quality and consistency
const Icons = {
  home: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>,
  profile: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>,
  details: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>,
  loyalty: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>,
  customers: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
  campaigns: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.5 12H16c-.7 0-1.4.3-1.9.8l-2.3 2.7c-.3.4-.8.5-1.3.5h-2c-.5 0-1-.1-1.4-.4l-1.6-1.2c-.6-.4-1.4-.5-2-.2L2 16"></path><path d="M21.5 6H16c-.7 0-1.4.3-1.9.8l-2.3 2.7c-.3.4-.8.5-1.3.5h-2c-.5 0-1-.1-1.4-.4L6 8.5c-.6-.4-1.4-.5-2-.2L2 10"></path><path d="M21.5 18H16c-.7 0-1.4.3-1.9.8l-2.3 2.7c-.3.4-.8.5-1.3.5h-2c-.5 0-1-.1-1.4-.4l-1.6-1.2c-.6-.4-1.4-.5-2-.2L2 22"></path></svg>,
  specials: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"></path><path d="M2 17l10 5 10-5"></path><path d="M2 12l10 5 10-5"></path></svg>,
  bookings: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
  events: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><path d="M16 2v4"></path><path d="M8 2v4"></path><path d="M3 10h18"></path><path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path></svg>,
  reports: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 20V10"></path><path d="M12 20V4"></path><path d="M6 20v-6"></path></svg>,
  reviews: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>,
  menu: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>,
  close: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
  edit: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>,
  save: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>,
  cancel: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>,
  about: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>,
  activate: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>,
  deactivate: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>,
  qr: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>,
  download: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>,
  logout: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>,
  collapse: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>,
  expand: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>,
  bookingV2: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line><path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"></path></svg>,
};

function VendorDashboard() {
  const [activeTab, setActiveTab] = useState('home');
  const [programs, setPrograms] = useState([]);
  const [newProgram, setNewProgram] = useState({ name: '', description: '', stamps_required: '', about: '' });
  const [customers, setCustomers] = useState([]);
  const [redeemPin, setRedeemPin] = useState('');
  const [pushNotification, setPushNotification] = useState({ title: '', body: '' });
  const [notificationStatus, setNotificationStatus] = useState(null);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [emailsSent, setEmailsSent] = useState(0);
  const [emailLimit, setEmailLimit] = useState(3000);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [emailSendResult, setEmailSendResult] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const navigate = useNavigate();
  const [qrCodes, setQRCodes] = useState({});
  const [editingProgram, setEditingProgram] = useState(null);
  const [tempProgram, setTempProgram] = useState(null);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [vendor, setVendor] = useState(null);
  const [activeProfileSection, setActiveProfileSection] = useState(null);
  const [profileMessage, setProfileMessage] = useState('');
  const [isSendingNotification, setIsSendingNotification] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoadingCustomer, setIsLoadingCustomer] = useState(false);
  
  // Reference for handling clicks outside dropdown menus
  const userMenuRef = useRef(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  
  // Handle clicks outside user menu
  useEffect(() => {
    function handleClickOutside(event) {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Debounced data fetching
  const debouncedFetchData = useCallback(
    debounce(() => {
      fetchPrograms();
      fetchCustomers();
      fetchEmailStats();
    }, 300),
    []
  );

  // Initial load and authentication check
  useEffect(() => {
    const checkAuthAndFetchData = async () => {
      const token = localStorage.getItem('token');
      if (!token || !isTokenValid()) {
        localStorage.removeItem('token');
        navigate('/login');
        return;
      }
  
      try {
        setAuthToken(token);
        
        // Use the profile response
        const response = await axios.get('/api/vendors/profile');
        setVendor(response.data);
        
        // Fetch other dashboard data
        debouncedFetchData();
      } catch (error) {
        console.error('Error verifying token or fetching vendor data:', error);
        
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          setAuthToken(null);
          navigate('/login');
        }
      }
    };
  
    checkAuthAndFetchData();
  
    // Handle mobile menu on resize
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      debouncedFetchData.cancel();
      window.removeEventListener('resize', handleResize);
    };
  }, [navigate, debouncedFetchData]);

  const location = useLocation();
useEffect(() => {
  const t = new URLSearchParams(location.search).get('tab');
  if (t) setActiveTab(t);
}, [location.search]);

  // Toggle mobile sidebar
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Fetch email statistics
  const fetchEmailStats = async () => {
    try {
      const response = await axios.get('/api/vendors/email-stats');
      setEmailsSent(response.data.emailsSent);
      setEmailLimit(response.data.emailLimit);
    } catch (error) {
      console.error('Error fetching email stats:', error);
    }
  };

  // Handle profile update success
  const handleProfileSuccess = (msg) => {
    setActiveProfileSection(null);
    setProfileMessage(msg);
    setTimeout(() => {
      setProfileMessage('');
      fetchVendorProfile();
    }, 2000);
  };

  // Fetch loyalty programs
  const fetchPrograms = async () => {
    try {
      const response = await axios.get('/api/vendors/dashboard-programs');
      setPrograms(response.data.map(program => ({
        ...program,
        allow_qr_checkin: program.allow_qr_checkin || false
      })));
    } catch (error) {
      console.error('Error fetching programs:', error);
    }
  };

  // Fetch customers
  const fetchCustomers = async () => {
    try {
      const response = await axios.get('/api/vendors/customers');
      setCustomers(response.data);
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };



  // Cancel program edit
  const handleCancelEdit = () => {
    setEditingProgram(null);
    setTempProgram(null);
  };

  // Show about modal
  const handleAboutClick = (program) => {
    setSelectedProgram(program);
    setShowAboutModal(true);
  };

  // Update program about
  const handleUpdateAbout = async (updatedAbout) => {
    try {
      await axios.put(`/api/vendors/programs/${selectedProgram.id}`, {
        ...selectedProgram,
        about: updatedAbout
      });
      setPrograms(programs.map(p => 
        p.id === selectedProgram.id ? { ...p, about: updatedAbout } : p
      ));
      setShowAboutModal(false);
    } catch (error) {
      console.error('Error updating program about:', error);
    }
  };

  // Send push notification
  const handlePushNotificationSubmit = async (e) => {
    e.preventDefault();
    setNotificationStatus(null);
    setIsSendingNotification(true);
    try {
      const response = await axios.post('/api/vendors/send-push-notification', {
        title: pushNotification.title,
        body: pushNotification.body
      });
      console.log('Push notification response:', response.data);
      setNotificationStatus({
        success: true,
        message: `Push notifications sent successfully. Success: ${response.data.successCount}`
      });
      setPushNotification({ title: '', body: '' });
    } catch (error) {
      console.error('Error sending push notifications:', error);
      setNotificationStatus({
        success: false,
        message: `Failed to send push notifications: ${error.response?.data?.error || error.message}`
      });
    } finally {
      setIsSendingNotification(false);
    }
  };

  // Send email campaign
  const handleEmailCampaignSubmit = async (emailContent, subject) => {
    setIsEmailModalOpen(false);
    setIsSendingEmail(true);
    try {
      const response = await axios.post('/api/vendors/send-campaign-email', {
        subject: subject,
        templateString: emailContent,
        data: {}
      });
      setEmailsSent(response.data.totalEmailsSent);
      setEmailSendResult({
        success: true,
        message: `Campaign email sent successfully. Success: ${response.data.successCount}, Errors: ${response.data.errorCount}`
      });
    } catch (error) {
      console.error('Error sending campaign email:', error);
      setEmailSendResult({
        success: false,
        message: error.response?.data?.error || 'Failed to send campaign email'
      });
    } finally {
      setIsSendingEmail(false);
    }
  };

  // Request email limit increase
  const handleRequestIncrease = () => {
    window.location.href = `mailto:duane@orderlocal.co.za?subject=Request%20Email%20Limit%20Increase&body=Current%20limit:%20${emailLimit}%0D%0AEmails%20sent:%20${emailsSent}`;
  };

  // Toggle QR check-in
  const toggleQRCheckin = async (programId) => {
    try {
      const response = await axios.put(`/api/vendors/programs/${programId}/toggle-qr-checkin`);
      setPrograms(programs.map(program => 
        program.id === programId ? {...program, allow_qr_checkin: response.data.allow_qr_checkin} : program
      ));
    } catch (error) {
      console.error('Error toggling QR check-in:', error);
    }
  };

  // Generate QR code
  const generateQRCode = async (programId) => {
    try {
      const response = await axios.get(`/api/vendors/programs/${programId}/qr-code`);
      setQRCodes(prevCodes => ({...prevCodes, [programId]: response.data.qrCode}));
    } catch (error) {
      console.error('Error generating QR code:', error);
    }
  };

  // Fetch vendor profile
  const fetchVendorProfile = async () => {
    try {
      const response = await axios.get('/api/vendors/profile');
      setVendor(response.data);
    } catch (error) {
      console.error('Error fetching vendor profile:', error);
    }
  };

  // Get available tabs
  const getTabs = () => {
    const tabs = [
      { id: 'home', label: 'Dashboard', icon: Icons.home },
      { id: 'generalDetails', label: 'General Details', icon: Icons.details },
      { id: 'loyaltyPrograms', label: 'Loyalty Programs', icon: Icons.loyalty },
      { id: 'customerRedemption', label: 'Customer Redemption', icon: Icons.customers },
      { id: 'campaigns', label: 'Campaigns', icon: Icons.campaigns },
      { id: 'specialsAndMenus', label: 'Specials & Menus', icon: Icons.specials },
      { id: 'bookingRequests', label: 'Booking Requests', icon: Icons.bookings },
      { id: 'reporting', label: 'Reports', icon: Icons.reports },
      { id: 'reviews', label: 'Reviews', icon: Icons.reviews },
    ];

     // Add V2 Booking tab for beauty sector vendors
  // if (vendor?.business_sector === 'beauty' && vendor?.booking_v2_enabled) {
  if (vendor?.booking_v2_enabled) {
    tabs.splice(7, 0, { // Insert after regular booking requests
      id: 'bookingV2', 
      label: 'Booking V2', 
      icon: Icons.bookingV2,
      badge: 'NEW',
      description: 'Advanced booking system for beauty & spa'
    });
  }

    // Only add events tab if vendor has events enabled
    if (vendor?.events_enabled) {
      tabs.push({ id: 'events', label: 'Events Management', icon: Icons.events });
    }

    return tabs;
  };
  
  // Get active tab label
  const getActiveTabLabel = () => {
    if (activeTab === 'profile') return 'Profile & Security';
    
    const tab = getTabs().find(tab => tab.id === activeTab);
    return tab ? tab.label : 'Dashboard';
  };

  // Render tab content
  const renderTabContent = () => {
    switch(activeTab) {
      case 'home':
        return <HomeTab />;
   // In VendorDashboard.js, update the profile section:

case 'profile':
  return (
    <div className="profile-section">
      <div className="gd-card">
        <div className="gd-card-header">
          <h2>Profile & Security Settings</h2>
        </div>
        <div className="gd-card-body">
          {profileMessage ? (
            <div className="gd-toast success">
              <div className="gd-toast-content">
                <span className="gd-toast-icon success">✓</span>
                <span className="gd-toast-message">{profileMessage}</span>
              </div>
            </div>
          ) : (
            <>
              <div className="current-info">
                <h3>Current Information</h3>
                <div className="gd-form-grid">
                  <div className="gd-form-group">
                    <label className="gd-label">Business Name</label>
                    <span>{vendor?.business_name}</span>
                  </div>
                  <div className="gd-form-group">
                    <label className="gd-label">Email</label>
                    <span>{vendor?.email}</span>
                  </div>
                  <div className="gd-form-group">
                    <label className="gd-label">Sub URL</label>
                    <span>{vendor?.sub_url}</span>
                  </div>
                </div>
              </div>

              {!activeProfileSection ? (
                <div className="gd-form-actions profile-section-actions" style={{ justifyContent: 'flex-start', gap: '16px' }}>
                  <button 
                    className="gd-button primary"
                    onClick={() => setActiveProfileSection('email')}
                  >
                    Change Email Address
                  </button>
                  <button 
                    className="gd-button primary"
                    onClick={() => setActiveProfileSection('password')}
                  >
                    Change Password
                  </button>
                </div>
              ) : (
                <div className="edit-section">
                  {activeProfileSection === 'email' && (
                    <EmailChange 
                      currentEmail={vendor?.email}
                      isModal={true}
                      isVendor={true}
                      onClose={() => setActiveProfileSection(null)}
                      onSuccess={handleProfileSuccess}
                    />
                  )}
                  {activeProfileSection === 'password' && (
                    <PasswordReset 
                      isModal={true}
                      isVendor={true}
                      isLoggedOut={false}
                      onClose={() => setActiveProfileSection(null)}
                      onSuccess={handleProfileSuccess}
                    />
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
      case 'generalDetails':
        return <GeneralDetails />;
      case 'loyaltyPrograms':
        return <LoyaltyPrograms />;
      case 'customerRedemption':
        return (
          <div className="cr-container">
            <div className="cr-card">
              <div className="cr-card-header">
                <h2 className="cr-card-title">Customer Redemption</h2>
              </div>
              <div className="cr-card-body">
                <CustomerSearch onSelectCustomer={setSelectedCustomer} />
                
                {/* Selected customer notification */}
                {selectedCustomer && !isLoadingCustomer && (
                  <div className="cr-selected-notification">
                    <div className="cr-selected-customer">
                      <div className="cr-customer-avatar">
                        {selectedCustomer.full_name.charAt(0).toUpperCase()}
                      </div>
                      <div className="cr-customer-info">
                        <span>{selectedCustomer.full_name}</span>
                      </div>
                    </div>
                    <button 
                      className="cr-button secondary"
                      onClick={() => setSelectedCustomer(null)}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                      <span>Clear Selection</span>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {selectedCustomer && (
              <div className="cr-profile-card cr-card">
                <div className="cr-card-header">
                  <h2 className="cr-card-title">Customer Profile</h2>
                  <button className="cr-close-button" onClick={() => setSelectedCustomer(null)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
                <div className="cr-card-body">
                  <CustomerProfile 
                    customerId={selectedCustomer.id} 
                    onClose={() => setSelectedCustomer(null)}
                  />
                </div>
              </div>
            )}
          </div>
        );
      case 'campaigns':
        return <Campaigns />;
      case 'specialsAndMenus':
        return <SpecialsAndMenus />;
      case 'bookingRequests':
        return <BookingManagement />;
         case 'bookingV2': 
      return <BookingV2Dashboard />;
      case 'events':
        return vendor?.events_enabled ? <EventsManagement /> : null;
      case 'reporting':
        return <Reporting />;
      case 'reviews':
        return <ReviewManagement />;
      default:
        return <HomeTab />; 
    }
  };

  return (
    <div className="vendor-dashboard">
      {/* Mobile menu toggle button - only visible on mobile */}
      <button 
        className="sidebar-toggle" 
        onClick={toggleMobileMenu}
        aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
      >
        {isMobileMenuOpen ? Icons.close : Icons.menu}
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarCollapsed ? 'collapsed' : ''} ${isMobileMenuOpen ? 'expanded' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            {!isSidebarCollapsed && "MyLocal"}
          </div>
          {!isMobileMenuOpen && (
            <button 
              className="sidebar-toggle"
              id="sidebardesktop"
              onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
              aria-label={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              {isSidebarCollapsed ? Icons.expand : Icons.collapse}
            </button>
          )}
        </div>

        <div className="sidebar-menu">
          <button 
            onClick={() => {
              setActiveTab('profile');
              if (window.innerWidth <= 768) setIsMobileMenuOpen(false);
            }} 
            className={activeTab === 'profile' ? 'active' : ''}
            aria-label="Profile & Security"
          >
            {Icons.profile} <span>Profile & Security</span>
          </button>

          {!isSidebarCollapsed && <h4 className="menu-category">Main Menu</h4>}
          
          {getTabs().map(tab => (
            <button 
              key={tab.id}
              onClick={() => {
                setActiveTab(tab.id);
                if (window.innerWidth <= 768) setIsMobileMenuOpen(false);
              }} 
              className={activeTab === tab.id ? 'active' : ''}
              aria-label={tab.label}
            >
              {tab.icon} <span>{tab.label}</span>
            </button>
          ))}
          
          {!isSidebarCollapsed && <h4 className="menu-category">Account</h4>}
          
          <button 
            onClick={logout} 
            className="logout-btn"
            aria-label="Logout"
          >
            {Icons.logout} <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className={`tab-content ${isSidebarCollapsed ? 'collapsed' : ''} ${isMobileMenuOpen ? 'expanded' : ''}`}>
        <div className="header-vdash">
          <h1>{getActiveTabLabel()}</h1>
          <div className="header-actions">
            <div className="user-profile" onClick={() => setUserMenuOpen(!userMenuOpen)} ref={userMenuRef}>
              <div className="user-avatar">
                {vendor?.business_name ? vendor.business_name.charAt(0).toUpperCase() : 'V'}
              </div>
              <span>{vendor?.business_name || 'Vendor'}</span>
              
              {userMenuOpen && (
                <div className="user-menu">
                  <ul>
                    <li onClick={() => setActiveTab('profile')}>Profile Settings</li>
                    <li onClick={logout}>Logout</li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        {renderTabContent()}
      </div>
    </div>
  );
}

export default VendorDashboard;